<app-topnav [pageName]="pageName"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <app-email-queue-list></app-email-queue-list>
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>